enum BoundaryDataSet {
  MEDIAN_INCOME = "income",
  POPULATION = "population",
}

export default BoundaryDataSet;
